'use strict';

var React = require('react');

var SvgFolderDownIcon = function SvgFolderDownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.75c0-.69.56-1.25 1.25-1.25h1.514c.473 0 .906.268 1.118.691l.17.342a1.75 1.75 0 0 0 1.566.967h4.132c.69 0 1.25.56 1.25 1.25v.5a.75.75 0 0 0 1.5 0v-.5a2.75 2.75 0 0 0-2.75-2.75h-4.132a.25.25 0 0 1-.224-.138l-.17-.342a2.75 2.75 0 0 0-2.46-1.52h-1.514a2.75 2.75 0 0 0-2.75 2.75v6.5a2.75 2.75 0 0 0 2.75 2.75h5a.75.75 0 0 0 0-1.5h-5c-.69 0-1.25-.56-1.25-1.25v-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5a.75.75 0 0 0-1.5 0v2.94l-.72-.72a.75.75 0 1 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l2-2a.75.75 0 1 0-1.06-1.06l-.72.72v-2.94Z"
  }));
};
SvgFolderDownIcon.displayName = "FolderDownIcon";

exports.SvgFolderDownIcon = SvgFolderDownIcon;
